import { Component } from 'react';
import { datadogRum } from "@datadog/browser-rum";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const renderingError = new Error(error.message);
    renderingError.name = `ReactRenderError`;
    renderingError.stack = errorInfo.componentStack;
    renderingError.cause = error;
    datadogRum.addError(renderingError);
  }

  render() {
    return (this.state.hasError)
      ? this.props.fallback
      : this.props.children;
  }
}